export const TIME_INTERVAL_GET_ROLE = 1000 * 60 * 5
